import { createClient } from "@supabase/supabase-js";

const supabaseUrl = "https://dkgmhkcdwmjjbdwxynqy.supabase.co";
const supabaseKey =
	"eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImRrZ21oa2Nkd21qamJkd3h5bnF5Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3MjE0ODM5NjcsImV4cCI6MjAzNzA1OTk2N30.alra3iGtcxd8KGpo_Fx5GIVDi8XGUysO4Sj0Tbvvl6Q";

export const supabase = createClient(supabaseUrl, supabaseKey);
